import React from 'react'
import { FieldError, UseFormRegisterReturn } from 'react-hook-form'

type MwInputProps = {
  register: UseFormRegisterReturn
  error?: FieldError
  placeholder?: string
}

const MwInput: React.FC<MwInputProps> = ({ register, error, placeholder }) => {
  return (
    <>
      <input
        className={`w-full ${error && 'contactSubmitError'}`}
        {...register}
        placeholder={placeholder}
      />
      {error && <p className="contactSubmitErrorMessage">{error.message}</p>}
    </>
  )
}

export default MwInput
